"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserManagementLabels = exports.getSpendingLabels = exports.getProfileManagementLabels = exports.getPayApplicationLabels = exports.getNotificationsLabels = exports.getInnBusinessLayoutLabels = exports.getInnBusinessHeaderLabels = exports.getInitials = exports.getHomepageLabels = exports.getFooterLabels = exports.getCompanyManagementLabels = exports.getCardManagementLabels = exports.getBusinessTypeLabel = exports.getAuthLabels = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _gql = require("../gql");
var getFooterLabels = exports.getFooterLabels = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (language) {
    return yield (0, _gql.executeGraphQLQueries)((0, _api.getFooterDetails)(), {
      language,
      country: language === 'en' ? 'gb' : 'de',
      site: 'business-booker'
    }, result => {
      var _result$data;
      return result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.footer;
    });
  });
  return function getFooterLabels(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getInnBusinessHeaderLabels = exports.getInnBusinessHeaderLabels = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(function* (language) {
    return yield (0, _gql.executeGraphQLQueries)((0, _api.getInnBusinessHeader)(), {
      language,
      country: language === 'en' ? 'gb' : 'de',
      businessBooker: true
    }, result => {
      var _result$data2;
      return result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 || (_result$data2 = _result$data2.headerInformation) === null || _result$data2 === void 0 ? void 0 : _result$data2.innBusinessHeader;
    });
  });
  return function getInnBusinessHeaderLabels(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getCardManagementLabels = exports.getCardManagementLabels = function () {
  var _ref3 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getCardManagementLabels)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data3;
      return result === null || result === void 0 || (_result$data3 = result.data) === null || _result$data3 === void 0 || (_result$data3 = _result$data3.getPageData) === null || _result$data3 === void 0 ? void 0 : _result$data3.cardManagementEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getCardManagementLabels(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var getInnBusinessLayoutLabels = exports.getInnBusinessLayoutLabels = function () {
  var _ref4 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getInnBusinessLayoutLabels)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data4;
      return result === null || result === void 0 || (_result$data4 = result.data) === null || _result$data4 === void 0 || (_result$data4 = _result$data4.getPageData) === null || _result$data4 === void 0 ? void 0 : _result$data4.layoutEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getInnBusinessLayoutLabels(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
var getUserManagementLabels = exports.getUserManagementLabels = function () {
  var _ref5 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getUserManagementLabels)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data5;
      return result === null || result === void 0 || (_result$data5 = result.data) === null || _result$data5 === void 0 || (_result$data5 = _result$data5.getPageData) === null || _result$data5 === void 0 ? void 0 : _result$data5.userManagementEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getUserManagementLabels(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
var getProfileManagementLabels = exports.getProfileManagementLabels = function () {
  var _ref6 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getProfileManagementLabelsQuery)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data6;
      return result === null || result === void 0 || (_result$data6 = result.data) === null || _result$data6 === void 0 || (_result$data6 = _result$data6.getPageData) === null || _result$data6 === void 0 ? void 0 : _result$data6.profileManagementEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getProfileManagementLabels(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
var getCompanyManagementLabels = exports.getCompanyManagementLabels = function () {
  var _ref7 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getCompanyManagementLabelsQuery)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data7;
      return result === null || result === void 0 || (_result$data7 = result.data) === null || _result$data7 === void 0 || (_result$data7 = _result$data7.getPageData) === null || _result$data7 === void 0 ? void 0 : _result$data7.companyManagementEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getCompanyManagementLabels(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
var getHomepageLabels = exports.getHomepageLabels = function () {
  var _ref8 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getHomepageLabelsQuery)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data8;
      return result === null || result === void 0 || (_result$data8 = result.data) === null || _result$data8 === void 0 || (_result$data8 = _result$data8.getPageData) === null || _result$data8 === void 0 ? void 0 : _result$data8.homepageEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getHomepageLabels(_x8) {
    return _ref8.apply(this, arguments);
  };
}();
var getSpendingLabels = exports.getSpendingLabels = function () {
  var _ref9 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getSpendingLabelsQuery)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data9;
      return result === null || result === void 0 || (_result$data9 = result.data) === null || _result$data9 === void 0 || (_result$data9 = _result$data9.getPageData) === null || _result$data9 === void 0 ? void 0 : _result$data9.spendingReportingEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getSpendingLabels(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
var getAuthLabels = exports.getAuthLabels = function () {
  var _ref10 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getAuthLabelsQuery)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data10;
      return result === null || result === void 0 || (_result$data10 = result.data) === null || _result$data10 === void 0 || (_result$data10 = _result$data10.getPageData) === null || _result$data10 === void 0 ? void 0 : _result$data10.authEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getAuthLabels(_x10) {
    return _ref10.apply(this, arguments);
  };
}();
var getPayApplicationLabels = exports.getPayApplicationLabels = function () {
  var _ref11 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getPayApplicationLabelsQuery)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data11;
      return result === null || result === void 0 || (_result$data11 = result.data) === null || _result$data11 === void 0 || (_result$data11 = _result$data11.getPageData) === null || _result$data11 === void 0 ? void 0 : _result$data11.payApplicationEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getPayApplicationLabels(_x11) {
    return _ref11.apply(this, arguments);
  };
}();
var getInitials = (firstName, lastName) => {
  return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
};
exports.getInitials = getInitials;
var getNotificationsLabels = exports.getNotificationsLabels = function () {
  var _ref12 = (0, _asyncToGenerator2.default)(function* (language) {
    var data = yield (0, _gql.executeGraphQLQueries)((0, _api.getNotificationsLabelsQuery)(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data12;
      return result === null || result === void 0 || (_result$data12 = result.data) === null || _result$data12 === void 0 || (_result$data12 = _result$data12.getPageData) === null || _result$data12 === void 0 ? void 0 : _result$data12.notificationsEndpoint;
    });
    return data ? JSON.parse(data) : null;
  });
  return function getNotificationsLabels(_x12) {
    return _ref12.apply(this, arguments);
  };
}();
var getBusinessTypeLabel = (businessType, t) => {
  var businessTypeLabels = {
    [_api.BusinessType.Charity]: t('payApplication.companyDetails.businessType.charity'),
    [_api.BusinessType.GovernmentFundedSchool]: t('payApplication.companyDetails.businessType.government.fund'),
    [_api.BusinessType.Government]: t('payApplication.companyDetails.businessType.government'),
    [_api.BusinessType.LimitedCompany]: t('payApplication.companyDetails.businessType.limitedCompany'),
    [_api.BusinessType.Partnership]: t('payApplication.companyDetails.businessType.partner'),
    [_api.BusinessType.PublicLimited]: t('payApplication.companyDetails.businessType.public.limited'),
    [_api.BusinessType.SoleTrader]: t('payApplication.companyDetails.businessType.soleTrader'),
    [_api.BusinessType.Other]: t('payApplication.companyDetails.businessType.other')
  };
  return businessTypeLabels[businessType] || '';
};
exports.getBusinessTypeLabel = getBusinessTypeLabel;